<script setup>
    import { router } from '@inertiajs/vue3';

    // includes we need to front end locale magic
    import { useI18n } from 'vue-i18n';
    // Get locale as set in cookie
    let { locale } = useI18n({ useScope: 'global' });

    const props = defineProps({
        toolkit: Object,
        awards: Object,
        actions: Array,
        currentToolkitTeams: Object,
        currentUserTeam: Number,
        loggedInUserId: Number,
    });

    const programme = router.page.props.ziggy.programme;
    const organisation = router.page.props.ziggy.organisation;
    const urlNamePrefix = organisation ? "gi." : "";

    // Set up widget variables
    const actions = props.actions;
    const toolkit = props.toolkit;
    const currentUserID = props.loggedInUserId;
    const awards = props.toolkit.awards;
    const currentTeamID = props.currentUserTeam;
    const currentToolkitTeams = props.currentToolkitTeams;
    let currentTeam = [];

    currentToolkitTeams.forEach(function (currentToolkitTeam) {
        if ( currentToolkitTeam.length !== 0 && currentToolkitTeam.id == currentTeamID ) {
            currentTeam = currentToolkitTeam;
        }
    });

    let team_custom_name = programme.team_custom_name;
    if (team_custom_name) {
        if(team_custom_name.constructor.name != 'Object') {
            team_custom_name = JSON.parse(team_custom_name);
        }
    }

    let default_team_name;

    if (locale.value == 'cy') {
        default_team_name = 'tîm';

    } else  {
        default_team_name = 'team';
    }

    let team_name = default_team_name;

    if (team_custom_name) {
        team_name =  team_custom_name[locale.value] == null ? default_team_name : team_custom_name[locale.value];
    }

    function progressBarWidth(progress) {
        if ( progress == 0 ) {
            return 'width:' + progress + '%; background-color: transparent;';
        }
        else {
            return 'width:' + progress + '%;';
        }
    }

</script>

<template>
    <div class="dashboard-widget widget awards-progress-widget">
        <div class="widget-header flex justify-between">
            <span>{{ $t('dashboard.widgets.awards.title') }}</span>
            <span class="material-icons-outlined rotate-90">bar_chart</span>
        </div>
        <div class="widget-content">
            <p v-if="toolkit.scoring == 'Points'" v-html="$t('dashboard.widgets.awards.points_score_status', { totalCompletedActions: currentTeam.totalCompletedActions, totalPoints: currentTeam.totalPoints, team_name: team_name })"></p>
            <p v-else v-html="$t('dashboard.widgets.awards.actions_score_status', { totalCompletedActions: currentTeam.totalCompletedActions, team_name: team_name })"></p>
            <div v-if="awards.length">
                <p>{{ $t('dashboard.widgets.awards.intro_text', { team_name: team_name }) }} </p>
                <div v-for="award in awards" class="action-award">
                    <div v-if="award.completed == 1" class="award-heading flex justify-between items-center award-completed">
                        <div class="flex items-center">
                            <span class="material-icons-outlined checkcircle mr-2">check_circle</span>
                            <span class="award-name">{{ award.name[$i18n.locale] ? award.name[$i18n.locale] : award.name[$i18n.fallbackLocale] }}</span>
                        </div>
                        <span class="award-current-status">{{ $t('dashboard.widgets.shared.status.done') }}</span>
                    </div>
                    <div v-else class="award-heading flex justify-between items-center award-in-progress">
                        <div class="flex items-center mr-2">
                            <span class="material-icons-outlined mr-2 checkcircle">radio_button_unchecked</span>
                            <span class="award-name">{{ award.name[$i18n.locale] ? award.name[$i18n.locale] : award.name[$i18n.fallbackLocale] }}</span>
                        </div>
                        <span class="award-current-status">{{ $t('dashboard.widgets.shared.status.in_progress') }}</span>
                    </div>

                    <ul class="award-criteria">
                        <li v-for="criteria in award.criteria" class="criteria flex w-full justify-between items-center">
                            <span class="w-1/3 pr-3 award-criteria-description flex items-center">
                                <span class="material-icons-outlined">arrow_right</span>
                                <span>{{ criteria.descriptive_title }}</span>
                            </span>
                            <div class="w-2/3">
                                <div class="progress-bar bg-success" role="progressbar" :style="progressBarWidth(criteria.progress)" aria-valuenow="{{criteria.progress}}" aria-valuemin="0" aria-valuemax="100">{{criteria.progress}}%</div>
                            </div>
                        </li>
                    </ul>


                </div>

            </div>
            <div v-else>
                <p>{{ $t('dashboard.widgets.awards.empty') }}</p>
            </div>


        </div>
    </div>
</template>
